
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_1wepg_1bxgk_99",
  "description": "awsui_description_1wepg_1bxgk_100",
  "label": "awsui_label_1wepg_1bxgk_101",
  "outline": "awsui_outline_1wepg_1bxgk_109",
  "show-outline": "awsui_show-outline_1wepg_1bxgk_112",
  "native-input": "awsui_native-input_1wepg_1bxgk_116",
  "wrapper": "awsui_wrapper_1wepg_1bxgk_120",
  "label-wrapper": "awsui_label-wrapper_1wepg_1bxgk_126",
  "empty-content": "awsui_empty-content_1wepg_1bxgk_137",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_1bxgk_147",
  "label-disabled": "awsui_label-disabled_1wepg_1bxgk_155",
  "description-disabled": "awsui_description-disabled_1wepg_1bxgk_156",
  "control": "awsui_control_1wepg_1bxgk_161"
};
  